import React from 'react';

import LoadingCircle from 'components/ui/LoadingCircle';

const Overlay = ({ text }) => {
  return (
    <div className="flex h-full w-full bg-green-200 opacity-75 absolute z-50">
      <div className="mx-auto my-auto">
        <LoadingCircle text={text} />
      </div>
    </div>
  );
};

export default Overlay;
